<footer class="page-footer center-on-small-only mt-0 primary-color" [ngClass]="{'fixed-bottom': fixedBottom}">
  <!--/.Call to action-->
  <!--Copyright-->
  <div class="footer-info">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm">
            <h5 class="h5-responsive mt-3">
              <i class="fa fa-envelope green-text" aria-hidden="true"></i>
              <a [href]='mailLink'>{{supportEmail}}</a>
            </h5>
          </div>
          <div class="col-sm">
            <h5 class="h5-responsive mt-3">
              <i class="fa fa-phone blue-text" aria-hidden="true"></i>
              <a [href]='phoneLink'>{{supportPhone}}</a>
            </h5>
          </div>
          <div class="col-sm">
            <h5 class="h5-responsive mt-3">
                <i class="fa fa-copyright" aria-hidden="true"></i> 2018 <a [href]="copyrightURL">{{copyrightTitle}}</a>
                <ul>
                <li><a [routerLink]="['/terms-and-conditions']">Terms and Conditions</a></li>
                <li><a [routerLink]="['/privacy']">Privacy Policy</a></li>
                <li><a [routerLink]="['/baa']">Business Associates Agreement</a></li>
                </ul>
            </h5>
          </div>
        </div>
      </div>
  </div>
  <!--/.Copyright-->

</footer>
<!--/.Footer-->


// WEBPACK FOOTER //
// ./src/app/theme/footer/footer.component.html